import { render } from "./BrochureTemplate.vue?vue&type=template&id=e30710e0&scoped=true"
import script from "./BrochureTemplate.vue?vue&type=script&lang=js"
export * from "./BrochureTemplate.vue?vue&type=script&lang=js"

import "./BrochureTemplate.vue?vue&type=style&index=0&id=e30710e0&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e30710e0"]])

export default __exports__